// 2026-09-02: "already printed?" for bulk print must be scoped to the location
// the user is printing FROM. Karen (Teams Lancaster) was warned about orders
// that had only been printed at Tinton Falls Warehouse.
//
// d: /api/orders/check-printed response { printed_ids, printed_by_loc }
// loc: shopify_location_id being printed from ('' / null = All Locations)
// Returns a Set of order GIDs considered already printed for this context.
export function printedIdsForLocation(d, loc) {
    const byLoc = (d && d.printed_by_loc) || {};
    if (!loc || !Object.keys(byLoc).length) {
        return new Set((d && d.printed_ids) || []);
    }
    const out = new Set();
    for (const [gid, locs] of Object.entries(byLoc)) {
        if ((locs || []).some(l => String(l.shopify_location_id) === String(loc) && l.printed)) out.add(gid);
    }
    return out;
}

// Tag fallback (orders the server didn't know about): only an
// `OpsHubPrinted <this location name>` tag counts when a location is set.
export function tagsSayPrintedHere(tags, locName) {
    const list = Array.isArray(tags) ? tags : [];
    if (!locName) return list.some(t => /^(opshubprinted|order printed|osp: order printed)/i.test(String(t).trim()));
    const want = `opshubprinted ${locName}`.toLowerCase().slice(0, 40);   // Shopify 40-char tag cap
    return list.some(t => String(t).trim().toLowerCase().slice(0, 40) === want);
}
